import { onWalkthroughScheduled } from "../services/client";
import moment from "moment";

export const scheduleWalkthrough = async (data, {user, walkthroughId, propertyManagerDetails}) => {
  const params = {
    walkthroughId, 
    PropertymanagerId : propertyManagerDetails?.propertyManager?.id || "",
    UserId: user?.id,
    HomeownerId: user?.id,
  }
  if(propertyManagerDetails.calendlyLink && propertyManagerDetails.calendlyAPIKey){
    const eventDetails = await fetch(data.data.payload.event.uri, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${propertyManagerDetails.calendlyAPIKey}`
      }
    })
    if(eventDetails.ok){
      const eventData = await eventDetails.json();
      const date = moment(eventData.resource.start_time).toDate();
      params['ScheduledAt'] = date;
      params['ScheduledDay'] = moment(date).format('dddd');
      params['ScheduledTime'] = moment(date).format('HH:mm A');
    }
  } else {
    const date = moment(data, 'YYYY-MM-DD HH:mm A').toDate()
    params['ScheduledAt'] = date;
    params['ScheduledDay'] = moment(date).format('dddd');
    params['ScheduledTime'] = moment(date).format('HH:mm A');
  }
  return onWalkthroughScheduled(params);

};